$(function() {
    let checkExetrnalIntervals = function(resolve, reject) {
        let orderDataEl = $("#order_data")
        let orderDeliveryDateEl = $("#order_delivery_date")
        let orderDeliveryTimeFromEl = $("#order_delivery_time_from")
        let orderServingTimeEl = $("#order_serving_time")
        let selectedDeliveryTypeEl = $('.delivery-type-select input[type="radio"]:checked')

        let data = {
            order_id: orderDataEl.attr("data-id"),
            delivery_type: selectedDeliveryTypeEl.val(),
            delivery_date: orderDeliveryDateEl.val(),
            delivery_time_from: orderDeliveryTimeFromEl.val(),
            serving_time: orderServingTimeEl.val()
        }

        return $.ajax({
            url: `/order_management/orders/external_restrictions`,
            data: data,
            method: "GET",
            dataType: "json",
            beforeSend: function(jqXHR, settings) {
                jqXHR.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
            },
            success: function(response) {
                resolve(response)
            },
            error: function(response) {
                console.log("Error in check restricted time intervals")
            }
        })
    }

    let setUpTimeIntervalsCheck = function() {
        let el = $('#order_delivery_date')
        el.on("dp.change", function() {
            new Promise((resolve, reject) => {
                checkExetrnalIntervals(resolve, reject)
            }).then((response)=> {
                if (response.restricted === true) {
                    const $picker = $(".order-datetimepicker");
                    showPickerError($picker, response.message, 'not-available-store')
                }else{
                  //const $picker = $(".order-datetimepicker");
                  //clearPickerError($picker, 'not-available-store')
                }
            })
        });
    }

    let setEvents = function() {
        setUpTimeIntervalsCheck()

    }
    setEvents()
})


    // --- Product time interval management ---
  document.addEventListener("DOMContentLoaded", function () {
    const productSelect = document.querySelector("#order_product_id");
    if (!productSelect) return;

    // Trigger on product change
    productSelect.addEventListener("change", function () {
      const productId = parseInt(this.value, 10);
      updateDatetimepicker(productId);
    });

    let locale = 'da'
    let dateFormat = 'D-M-YYYY'
    const moment = require('moment');
    moment.updateLocale(locale, {
      week: {
        dow: 2 // 0 = Sunday, 1 = Monday, 2 = Tuesday
      }
    });
    const $picker = $(".order-datetimepicker");
    $picker.datetimepicker({
      locale: locale,
      format: dateFormat,
      calendarWeeks: true,
    });

    // Bind dynamically so it survives re-inits
    $picker.on('dp.change', function() {
      const productId = parseInt(productSelect.value, 10);
      updateDatetimepicker(productId);
    });

    // --- initialize datetimepicker for the currently selected product ---
    const initialProductId = parseInt(productSelect.value, 10);
    if (!isNaN(initialProductId)) {
      updateDatetimepicker(initialProductId);
    }
  });
  function updateDatetimepicker(productId) {
    const product = window.productsTimeIntervals.find(
      (p) => p.id === productId
    );
    const intervals = product ? product.intervals : [];
    const systemIntervals = window.systemTimeIntervals || [];
    const allIntervals = intervals.concat(systemIntervals);

    const $picker = $(".order-datetimepicker");
    if (!$picker.length) return;

    // Always (re)initialize datetimepicker format first

    // If no intervals → allow all dates
    if (allIntervals.length === 0) {
      $picker.datetimepicker("options", { disabledDates: [] });
      clearPickerError($picker,  'not-available');
      return;
    }

    // Build list of disabled dates
    const disabledDates = [];
    allIntervals.forEach((interval) => {
      const start = moment(interval.from).startOf("day");
      const end = moment(interval.to).startOf("day");
      let current = start.clone();

      while (current.isSameOrBefore(end, "day")) {
        disabledDates.push(current.clone());
        current.add(1, "day");
      }
    });

    // Apply disabled dates to picker
    $picker.datetimepicker("options", {
      disabledDates,
    });

    // Check currently selected date
    const pickerDate =
      $picker.datetimepicker("viewDate") || $picker.datetimepicker("date");
    if (pickerDate) {
      const selected = moment(pickerDate).startOf("day");
      const isDisabled = disabledDates.some((d) => d.isSame(selected, "day"));
      if (isDisabled) {
        showPickerError(
          $picker,
          $picker.data('error-message-not-available') || 'Date not available',
          'not-available'
        );
      } else {
        clearPickerError($picker,  'not-available');
      }
    }
  }

  function showPickerError($picker, message, key) {
    $picker.addClass("is-invalid");

    // If no error element exists, create it
    let $error = $picker.siblings(".error-"+key);
    if (!$error.length) {
      $error = $('<div class="invalid-feedback error-'+key+'"></div>');
      $picker.after($error);
    }
    $error.text(message).show();
  }

  function clearPickerError($picker, key) {
    $picker.removeClass("is-invalid");
    $picker.siblings(".invalid-feedback.error-" + key).hide();
  }
